import React, { Component } from 'react'
import Radium from 'radium'
import Tabbutton from './tabbutton'

const styles = {
    tabbar: {
        backgroundColor: 'inherit',
    }
}

function Tabbar({ tabs, activeTab, onTabbuttonClicked }) {
    const buttons = tabs.map((tab, index) => {
        return <Tabbutton
            key={index}
            text={tab}
            onClick={() => onTabbuttonClicked(index)}
            active={activeTab == index}
        />
    })
    return <div
        style={styles.tabbar}>{buttons}</div>
}

export default Radium(Tabbar)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Invoice/tabbar/tabbar.js